import { render } from "./DownloadDataButton.vue?vue&type=template&id=0ec6cc06"
import script from "./DownloadDataButton.vue?vue&type=script&lang=js"
export * from "./DownloadDataButton.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__